import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // Hamburger menu state
  const [isProductsOpen, setIsProductsOpen] = useState(false); // Products dropdown state

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (isProductsOpen) setIsProductsOpen(false); // Close dropdown if open when hamburger toggles
  };

  const toggleProducts = () => {
    setIsProductsOpen(!isProductsOpen); // Toggle products dropdown
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/">
            <img src="/images/logo.svg" alt="EMPACK Logo" />
          </Link>
        </div>

        {/* Hamburger Button */}
        <button
          className={`hamburger ${isOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Menu Items */}
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>
              Acceuil
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/presentation" className="nav-link" onClick={() => setIsOpen(false)}>
              A propos
            </Link>
          </li>
          <li className="nav-item nav-item-products">
            <div
              className="nav-link products-toggle"
              onClick={toggleProducts}
              aria-expanded={isProductsOpen}
              aria-label="Toggle products submenu"
            >
              Produits
              <span className={`dropdown-arrow ${isProductsOpen ? 'open' : ''}`}>&#9662;</span>
            </div>
            {/* Submenu for Products */}
            <ul className={`submenu ${isProductsOpen ? 'active' : ''}`}>
              <li className="submenu-item">
                <Link
                  to="/categories/boite-expedition"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                    Boite d’expedition 
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/offset-imprime"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Papier offset imprimè 
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/sacs-imprime"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Sacs imprimé personnalisé
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/coffret-oreille"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Coffret A Oreille Imprimèe 
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/etuis"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Etuis imprimée
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/caisse-americaine"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Caisse Americaine
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/boite-avec-oreilles"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Boite Avec Oreilles
                </Link>
              </li>
              <li className="submenu-item">
                <Link
                  to="/categories/cartes"
                  className="submenu-link"
                  onClick={() => {
                    setIsOpen(false);
                    setIsProductsOpen(false);
                  }}
                >
                  Cartes
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;